import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";

export default function Hero() {
    const { t } = useT();
    return (
        <section data-testid="hero-section" className="relative pt-32 md:pt-40 pb-20 md:pb-32 overflow-hidden">
            <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-[#3D8C95]/10 blur-3xl" />
            <div className="absolute top-1/2 -left-32 w-80 h-80 rounded-full bg-[#C44569]/10 blur-3xl" />

            <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative">
                <div className="fade-up">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E8E2D9] mb-6">
                        <Sparkles size={14} className="text-[#E07A5F]" />
                        <span className="text-xs tracking-[0.2em] uppercase text-[#6E6862]">{t("hero.tag")}</span>
                    </div>

                    <h1 data-testid="hero-title" className="font-display text-5xl sm:text-6xl lg:text-7xl font-light text-[#2C2A29] leading-[1.05] tracking-tight">
                        {t("hero.title1")}
                        <span className="block italic text-[#E07A5F]">{t("hero.title2")}</span>
                    </h1>

                    <p className="mt-6 text-base md:text-lg text-[#6E6862] leading-relaxed max-w-xl">{t("hero.desc")}</p>

                    <div className="mt-10 flex flex-wrap gap-4">
                        <a href="#reservation">
                            <Button data-testid="hero-cta-book" className="rounded-full bg-[#E07A5F] hover:bg-[#D06A4F] text-white px-8 py-6 text-base transition-transform hover:-translate-y-1 shadow-[0_10px_30px_rgba(224,122,95,0.35)]">
                                {t("hero.cta_book")}
                                <ArrowRight size={18} className="ml-2" />
                            </Button>
                        </a>
                        <a href="#services">
                            <Button data-testid="hero-cta-services" variant="outline" className="rounded-full border-[#2C2A29] text-[#2C2A29] hover:bg-[#2C2A29] hover:text-white px-8 py-6 text-base">
                                {t("hero.cta_services")}
                            </Button>
                        </a>
                    </div>

                    <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
                        <div data-testid="stat-experience">
                            <div className="font-display text-3xl text-[#3D8C95]">3</div>
                            <div className="text-xs uppercase tracking-wider text-[#6E6862] mt-1">{t("hero.stat_exp")}</div>
                        </div>
                        <div data-testid="stat-techniques">
                            <div className="font-display text-3xl text-[#C44569]">7</div>
                            <div className="text-xs uppercase tracking-wider text-[#6E6862] mt-1">{t("hero.stat_tech")}</div>
                        </div>
                        <div data-testid="stat-rating">
                            <div className="font-display text-3xl text-[#E07A5F]">5★</div>
                            <div className="text-xs uppercase tracking-wider text-[#6E6862] mt-1">{t("hero.stat_rating")}</div>
                        </div>
                    </div>
                </div>

                <div className="relative fade-up delay-200">
                    <div className="relative">
                        <div className="absolute -inset-4 bg-gradient-to-br from-[#E07A5F]/20 via-transparent to-[#3D8C95]/20 rounded-[2.5rem] blur-2xl" />
                        <img src="https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtYXNzYWdlJTIwdGhlcmFweSUyMHJlbGF4fGVufDB8fHx8MTc4MTQwNzA0OXww&ixlib=rb-4.1.0&q=85"
                            alt="Massage" className="relative rounded-[2rem] shadow-2xl w-full object-cover aspect-[4/5]" data-testid="hero-image" />
                    </div>

                    <div className="absolute -bottom-6 -left-6 md:-left-12 bg-white rounded-2xl shadow-xl border border-[#E8E2D9] px-5 py-4 flex items-center gap-3 floaty">
                        <div className="w-10 h-10 rounded-full bg-[#3D8C95] flex items-center justify-center text-white">
                            <Sparkles size={18} />
                        </div>
                        <div>
                            <div className="text-xs uppercase tracking-wider text-[#6E6862]">{t("hero.from_price")}</div>
                            <div className="font-display text-xl text-[#2C2A29]">70 $ {t("hero.per_session")}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
